import PropTypes from 'prop-types';

import React from 'react';

/**
 * Represents a very minimal table designed to only display data
 * @returns {ReactElement} The rendered result
 */
let DataTable = ({data, headerRow = null, footerRow = null, widths = null, className = '', style = {}}) => {
  return <table className={'table table-striped' + (className ? ' ' + className : '')}
                style={style}>
    {
      headerRow && headerRow.length ?
        <thead>
          <tr>
            {headerRow.map((text, index) => {
              let style = {};

              if (widths && widths[index]) {
                style.width = widths[index];
              }
              return <th key={index}
                       style={style}>{text}</th>;
            })}
          </tr>
        </thead> :
        null
    }
    <tbody>
      {(data || []).map((row, rowIndex) =>
        <tr key={rowIndex}>
          {row.map((value, index) => <td key={index}>{value}</td>)}
        </tr>
    )}
    </tbody>
    {
      footerRow && footerRow.length ?
        <tfoot>
          {className && className.indexOf('table-footer-summary') > -1 ? <tr className="spacer">
            <td colSpan={footerRow.length}/>
          </tr> : null}
          <tr>
            {footerRow.map((text, index) => {
              let style = {};

              if (widths && widths[index]) {
                style.width = widths[index];
              }
              if (!text) {
                return <td key={index}
                         className='empty'
                         style={style}>{text}</td>;
              }
              return <td key={index}
                       style={style}>{text}</td>;
            })}
          </tr>
        </tfoot> :
        null
    }
  </table>;
};

DataTable.propTypes = {
  headerRow: PropTypes.array,
  data: (props, propName, componentName) => {
    let result = PropTypes.checkPropTypes({[propName]: PropTypes.array}, props, propName, componentName);

    if (result) {
      return result;
    }

    let arrays = props[propName];

    for (let i = 0; i < arrays.length; i++) {
      let row = arrays[i];

      if (!Array.isArray(row)) {
        return new Error(`Expected an array at position ${i} of prop '${propName}' in component ${componentName}.`);
      }
    }
  },
};

export default DataTable;
